
import { motion } from "framer-motion";

export const BenefitsSectionSv = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.7 }}
      className="mb-10"
    >
      <h2 className="text-2xl font-bold mb-6 text-blue-700">Varför jämföra lån via Lainasampo.fi?</h2>
      <div className="bg-white p-6 rounded-lg shadow-sm border border-blue-100">
        <div className="space-y-6">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="bg-blue-50 p-4 rounded-lg flex items-center justify-center md:w-1/4">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-600">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
                <path d="M3 6h18"></path>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
              </svg>
            </div>
            <div className="md:w-3/4">
              <h3 className="text-xl font-semibold text-blue-700 mb-2">Spara tid och besvär</h3>
              <p className="text-gray-700">
                Med Lainasampo.fi kan du jämföra över 30 banker och finansinstitut med en enda ansökan. 
                Detta sparar avsevärt med tid jämfört med att ansöka om lån från varje bank separat.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row gap-4">
            <div className="bg-blue-50 p-4 rounded-lg flex items-center justify-center md:w-1/4">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-600">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                <line x1="9" x2="9.01" y1="9" y2="9"></line>
                <line x1="15" x2="15.01" y1="9" y2="9"></line>
              </svg>
            </div>
            <div className="md:w-3/4">
              <h3 className="text-xl font-semibold text-blue-700 mb-2">Kostnadsfri tjänst</h3>
              <p className="text-gray-700">
                Vår tjänst är helt kostnadsfri för dig. Vi finansierar vår verksamhet genom provisioner som 
                betalas av banker och finansinstitut, så du kan använda vår tjänst utan oro för extra kostnader.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col md:flex-row gap-4">
            <div className="bg-blue-50 p-4 rounded-lg flex items-center justify-center md:w-1/4">
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-600">
                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
                <path d="m9 12 2 2 4-4"></path>
              </svg>
            </div>
            <div className="md:w-3/4">
              <h3 className="text-xl font-semibold text-blue-700 mb-2">Pålitlig jämförelse</h3>
              <p className="text-gray-700">
                Vi jämför alla lånekostnader, räntor och villkor åt dig. Du får en tydlig sammanfattning 
                av olika alternativ, vilket gör att du kan fatta beslut enkelt och snabbt.
              </p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
